export default {
  plugMidiKeyboardPanel: {
    title: 'tips',
    subtitle: 'plug in your keyboard to benefit from everything tokatab can offer you!',
    learnMore: 'Learn more',
    close: 'Close',
    dontRemindMe: 'Don\'t remind me anymore',
  },
  savoirPlusMidiKeyboardPanel: {
    title: 'learn more',
    subtitle: 'most frequently asked questions',
    question1: 'What is a MIDI compatible keyboard and what is it for?',
    answer1Part1: 'A MIDI compatible keyboard is a keyboard you can use to control a virtual instrument on your device.',
    answer1Part2: 'With Tokatab, it will allow you to evaluate your playing, make the experience more fun and our assistance more precise!',
    answer1Part3: 'Tokatab integrates a virtual piano, just plug in your keyboard and enjoy the experience!',
    question2: 'How to recognize a MIDI keyboard and how to connect it?',
    question3: 'Where to buy a cable?',
    ok: 'ok',
    dontRemindMe: 'Don\'t remind me anymore',
  },
  plugMidiKeyboardBar: {
    shortMessage: 'Plug in your keyboard to enjoy Tokatab!',
    longMessage: 'Plug in your keyboard to enjoy the best possible experience on Tokatab!',
    learnMore: 'Learn more',
  },
};